import * as React from 'react';
import { Status } from './types';
import { useSession } from './useSession';
export var IsNotAuthenticated = function (_a) {
    var children = _a.children;
    var status = useSession().status;
    if ([Status.Authenticated, Status.Unauthenticating].includes(status)) {
        return null;
    }
    // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=IsNotAuthenticated.js.map